module.exports = __webpack_public_path__ + "img/logo-plx-dev.7f3cef93.png";